export default {
  SET_AUTOMATION_TRIGGERS: 'setAutomationTriggers',
  SET_AUTOMATIONS: 'setAutomations',
  SET_SELECTED_AUTOMATION: 'setSelectedAutomation',
  SET_FIELD_TENANTS: 'setFieldTenants',
  SET_TENANT_PERMISSIONS: 'setTenantPermissions'
}
